import React, { useEffect, useRef, useState } from "react";
import FlexCard from "../Helpers/FlexCard";
import { Link } from "react-router-dom";

const REGEX = {
  number: /^[0-9]{10}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

const BackgroundVerification = (props) => {
  const formRef = useRef(null);
  const tabStatus = props.urlparams.params.status;
  const frompath = props?.urlparams?.params?.frompath;
  const isAdmin = props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  const isReadonly = props.urlparams.params.readonly === "true" ? true : false;
  const [activeTab] = useState("manual");
  const [error, setError] = useState({ name: "", message: "" });
  const [bgData, setBgData] = useState(null);
  const [customerId, setCustomerId] = useState(null);

  const hasError = !!error.message;

  /* ================= VALIDATION ================= */
  const validateField = (name, value) => {
    if (name === "phone" && !REGEX.number.test(value)) {
      return "Please enter a valid Mobile Number";
    }
    if (name === "email" && !REGEX.email.test(value)) {
      return "Please enter a valid Email Address";
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const message = validateField(name, value);
    setError(message ? { name, message } : { name: "", message: "" });
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = () => {
    if (hasError) return;

    const data = formRef.current?.form?.current?.getData?.() || {};
    const payload = Object.fromEntries(
      Object.entries(data).filter(
        ([_, value]) => value !== "" && value !== null && value !== undefined,
      ),
    );

    props.apis
      .apiUnderWriterPostSign3Data({ ...payload, customerId })
      .then((res) => {
        if (res) {
          setBgData(res);
          formRef.current?.form?.current?.reset?.();
        }
      });
  };

  const getUnderwriterInfo = () => {
    props.apis
      .apiGetUnderWriterApplicationDetails({
        applicationId: props.urlparams.params.id,
      })
      .then((res) => {
        if (res) {
          setCustomerId(res?.customerId);

          // Get sign3 details
          props.apis
            .apiUnderWriterGetSign3Data({
              customerId: res?.customerId,
            })
            .then((res) => {
              if (res) {
                setBgData(res);
              }
            });
        }
      });
  };
  /* ================= MOCK RESPONSE ================= */
  useEffect(() => {
    getUnderwriterInfo();
  }, []);

  /* ================= DATA MAPPING ================= */

  const customerIdentityData = {
    Name: bgData?.customerIdentityDetails?.name || "-",
    "Other Names":
      bgData?.customerIdentityDetails?.otherNames?.join(", ") || "-",
    "Phone Social Profile": bgData?.customerIdentityDetails?.phoneSocialProfile
      ? "Yes"
      : "No",
  };

  const riskScoreData = {
    "Phone Risk Score": bgData?.riskScores?.phoneRiskScore ?? "-",
    "Email Risk Score": bgData?.riskScores?.emailRiskScore ?? "-",
    "Phone–Email Linked Score":
      bgData?.riskScores?.phoneEmailLinkedScore ?? "-",
  };

  const socialDeviceData = {
    Messaging:
      bgData?.socialProfiles?.messagingApps?.map((i) => i.name).join(", ") ||
      "-",
    "Tech Products":
      bgData?.socialProfiles?.techApps?.map((i) => i.name).join(", ") || "-",
    "Social Media":
      bgData?.socialProfiles?.socialApps?.map((i) => i.name).join(", ") || "-",
    Travel:
      bgData?.socialProfiles?.travelApps?.map((i) => i.name).join(", ") || "-",
    Marketplace:
      bgData?.socialProfiles?.marketplaceApps?.map((i) => i.name).join(", ") ||
      "-",
  };

  const modelsData = {
    Age: bgData?.intelligenceInsights?.models?.age || "-",
    "Work Experience":
      bgData?.intelligenceInsights?.models?.workExperienceYears || "-",
    "Phone Age": bgData?.intelligenceInsights?.models?.phoneAge || "-",
    "Email & Phone Age":
      bgData?.intelligenceInsights?.models?.emailAndPhoneAge || "-",
  };

  const behavioralData = {
    Employed: bgData?.intelligenceInsights?.behavioralInsights?.employed
      ? "Yes"
      : "No",
  };

  const scoresData = {
    "Technocracy Score":
      bgData?.intelligenceInsights?.scores?.technocracyScore || "-",
    "LinkedIn Maturity":
      bgData?.intelligenceInsights?.scores?.linkedInMeturity || "-",
  };

  const recentEmploymentInformation = {
    "Member ID": bgData?.recentEmployementInformation?.memberId || "-",
    "Organization ID":
      bgData?.recentEmployementInformation?.organizationId || "-",
    "Organization Name":
      bgData?.recentEmployementInformation?.organizationName || "-",
    "Matching Status":
      bgData?.recentEmployementInformation?.matchingStatus || "-",
    "Date of Joining":
      bgData?.recentEmployementInformation?.dateOfJoining || "-",
    "Date of Exit": bgData?.recentEmployementInformation?.dateOfExit || "-",
    "Is Currently Employed": bgData?.recentEmployementInformation
      ?.isCurrentEmployeement
      ? "Yes"
      : "No",
    "PF Filing Details":
      bgData?.recentEmployementInformation?.pfFilingDetails[0]?.uan || "-",
    "Is Name Unique": bgData?.recentEmployementInformation?.isNameUnique
      ? "Yes"
      : "No",
    "DOE Marked": bgData?.recentEmployementInformation?.DOEMarked
      ? "Yes"
      : "No",
    "Employee Name Match":
      bgData?.recentEmployementInformation?.employeeNameMatch || "-",
  };

  const employeeDetails = {
    Name: bgData?.employeeDetails?.name || "-",
    Gender: bgData?.employeeDetails?.gender || "-",
    "Date Of Birth": bgData?.employeeDetails?.dateOfBirth || "-",
    "Member ID": bgData?.employeeDetails?.memberId || "-",
    "Aadhaar Verification Status":
      bgData?.employeeDetails?.aadhaarVerificationStatus || "-",
    "Employment Confidence Score":
      bgData?.employeeDetails?.employementConfidenceScore || "-",
  };

  const [activeKey, setActiveKey] = useState("behavioral");
  const intelligenceInsightsTabs = [
    {
      key: "behavioral",
      name: "Behavioral",
    },
    {
      key: "models",
      name: "Models",
    },
    {
      key: "scores",
      name: "Scores",
    },
  ];

  const handleSelect = (e, key) => {
    setActiveKey(key);
  };

  /* ================= UI ================= */

  return (
    <>
      <div className="card p-4">
        <h4 className="title mb-3">Input Details</h4>

        <AppForm ref={formRef} onSubmit={handleSubmit} className="row">
          <div className="col-12 col-md-4 col-lg-3">
            <AppInput
              type="text"
              name="phone"
              label="Mobile Number"
              placeholder="Please enter mobile no."
              onChange={handleChange}
              errorMessage={error.name === "phone" ? error : null}
            />
          </div>

          <div className="col-12 col-md-4 col-lg-3">
            <AppInput
              type="email"
              name="email"
              label="Email ID"
              placeholder="Please enter email ID"
              onChange={handleChange}
              errorMessage={error.name === "email" ? error : null}
            />
          </div>

          {!isAdmin && frompath !== "loandetails" && (
            <div className="col-12 col-md-4 col-lg-3 d-flex align-items-center mt-3">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={hasError}
              >
                Run Check
              </button>
            </div>
          )}
        </AppForm>
      </div>

      {bgData && (
        <>
          <div className="card p-4">
            <FlexCard
              title="Customer Identity Details"
              data={customerIdentityData}
            />
          </div>

          <div className="card p-4">
            <FlexCard title="Risk Scores" data={riskScoreData} />
          </div>

          <div className="card p-4">
            <FlexCard title="Social & Device Profile" data={socialDeviceData} />
          </div>

          <div className="filter_tab_container">
            <div className="flex_card_outer">
              <div className="flex_card">
                <h4 class="title">Intelligence Insights</h4>
              </div>
            </div>
            {intelligenceInsightsTabs.map((btn) => {
              return (
                <>
                  <button
                    type="button"
                    id={btn.key}
                    className={Object.className({
                      active: activeKey === btn.key,
                    })}
                    onClick={(...args) => handleSelect(...args, btn.key)}
                  >
                    {btn.name}
                  </button>
                </>
              );
            })}
          </div>

          {activeKey === "behavioral" && (
            <div className="card pt-0 px-4 pb-4 border-0">
              <FlexCard data={behavioralData} />
            </div>
          )}

          {activeKey === "models" && (
            <div className="card pt-0 px-4 pb-4 border-0">
              <FlexCard data={modelsData} />
            </div>
          )}

          {activeKey === "scores" && (
            <div className="card pt-0 px-4 pb-4 border-0">
              <FlexCard data={scoresData} />
            </div>
          )}

          <div className="card p-4">
            <FlexCard
              title="Recent Employment Information"
              data={recentEmploymentInformation}
            />
          </div>

          <div className="card p-4">
            <FlexCard title="Employee Details" data={employeeDetails} />
          </div>

          {!isAdmin && (
            <div className="nav_container mt-5">
              <Link
                to={`/app/loanapplications?activetab=${tabStatus}`}
                className="btn btn-primary-lite me-3"
              >
                Cancel
              </Link>

              {["approved", "sanctioned"].includes(tabStatus) || isReadonly ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(...args) =>
                    props.changeTab(...args, "incomedetails")
                  }
                >
                  Next
                </button>
              ) : (
                <button
                  type="button"
                  onClick={(e) => props.changeTab(e, "incomedetails")}
                  className="btn btn-primary"
                >
                  Submit
                </button>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default constore(BackgroundVerification);
